<div class="wager-card-wrapper">
  <canvas #confettiCanvas class="confetti-canvas"></canvas>
  <div
    role="button"
    class="wager-card"
    [ngClass]="{
      disabled: isDisabled(),
      locked: effectiveLockState() === 'locked',
      'in-progress': effectiveLockState() === 'inprogress',
      'celebrating-unlock': celebrationState() === 'unlock',
      'celebrating-unlock-transition': celebrationState() === 'unlock-transition',
      'celebrating-inprogress': celebrationState() === 'inprogress',
    }"
    (animationend)="onAnimationEnd($event)"
    [ngStyle]="cardStyle() | theme"
    [style.padding-top]="topPadding"
    [style.padding-bottom]="bottomPadding"
    [style.padding-left]="leftPadding"
    [style.padding-right]="rightPadding"
    [style.--unlock-progress-start]="celebrationStartPercent() + '%'"
    [style.--inprogress-target-percent]="progressPercent() + '%'"
    (keydown.enter)="onClick()"
    (keydown.space)="onClick()"
    (click)="onClick()"
    [attr.tabindex]="isDisabled() || lockState() !== 'unlocked' ? -1 : 0"
    [attr.aria-disabled]="isDisabled() || lockState() !== 'unlocked'"
    [attr.aria-label]="
      title() + ' — win ' + primaryPrizeAmount().text + ', enter ' + primaryEntryAmount().text
    "
  >
    @if (splicedBg) {
      <app-spliced-background
        [image]="splicedBg.imageUrl"
        [cornerSize]="splicedBg.cornerSize"
        [disabled]="isDisabled()"
      />
    }
    @if (hasWaitingOpponent() && !isDisabled()) {
      <app-icon
        icon="player-waiting"
        [colorCss]="playerWaitingColor"
        sizeCss="--icon-medium"
        class="player-waiting-icon"
      />
    }
    <div [ngStyle]="titleStyles() | theme">
      {{ title() }}
    </div>
    <app-wager-prize
      [primary]="primaryPrizeAmount()"
      [secondary]="secondaryPrizeAmount()"
      [textStyles]="prizeStyles()"
      [shadowStyles]="prizeShadowStyles()"
    />
    <div class="label-slot">
      @if (effectiveLockState() !== "inprogress" || celebrationState() === "unlock-transition") {
        <app-wager-entry-line
          [prefix]="prefixLabel"
          [prefixStyles]="enterStyle()"
          [primary]="primaryEntryAmount()"
          [secondary]="secondaryEntryAmount()"
          [feeStyles]="feeStyle()"
        />
      }
      @if (
        effectiveLockState() === "inprogress" ||
        celebrationState() === "unlock-transition" ||
        celebrationState() === "inprogress"
      ) {
        <div class="progress-bar-container">
          <div class="progress-bar-track">
            <div class="progress-bar-fill" [style.width.%]="progressPercent()"></div>
          </div>
          <div class="progress-counter-stack">
            <span
              class="progress-counter progress-counter--previous"
              [ngStyle]="progressCounterStyle | theme"
              >{{ previousCounterText() }}</span
            >
            <span
              class="progress-counter progress-counter--current"
              [ngStyle]="progressCounterStyle | theme"
              >{{ currentCounterText() }}</span
            >
          </div>
        </div>
      }
    </div>
    <div #buttonSlot class="button-slot">
      @if (effectiveLockState() === "unlocked" || celebrationState() === "unlock-transition") {
        <div class="play-button" [ngStyle]="playButtonStyles | theme">
          @if (splicedPlayBg) {
            <app-spliced-background
              [image]="splicedPlayBg.imageUrl"
              [cornerSize]="splicedPlayBg.cornerSize"
            />
          }
          <span [ngStyle]="playButtonLabelStyles | theme">{{ playLabel }}</span>
        </div>
      }
      @if (
        effectiveLockState() === "inprogress" ||
        celebrationState() === "unlock-transition" ||
        celebrationState() === "inprogress"
      ) {
        <div class="inprogress-button" [ngStyle]="inProgressButtonStyles | theme">
          @if (splicedInProgressBg) {
            <app-spliced-background
              [image]="splicedInProgressBg.imageUrl"
              [cornerSize]="splicedInProgressBg.cornerSize"
            />
          }
          <div class="inprogress-label-stack">
            <span
              class="inprogress-label inprogress-label--count"
              [ngStyle]="inProgressButtonLabelStyles | theme"
              >{{ previousInProgressLabel() }}</span
            >
            <span
              class="inprogress-label inprogress-label--unlocking"
              [ngStyle]="inProgressButtonLabelStyles | theme"
              >{{ unlockingLabel }}</span
            >
          </div>
        </div>
      }
      @if (effectiveLockState() === "locked" || celebrationState() === "inprogress") {
        <div class="locked-button" [ngStyle]="lockedButtonStyles | theme">
          @if (splicedLockedBg) {
            <app-spliced-background
              [image]="splicedLockedBg.imageUrl"
              [cornerSize]="splicedLockedBg.cornerSize"
            />
          }
          <span [ngStyle]="lockedButtonLabelStyles | theme">{{ lockedLabel }}</span>
        </div>
      }
    </div>
  </div>
</div>
